import React, {Fragment, useState} from "react";
import {useDispatch} from "react-redux";
import {customFieldActions} from "_actions";
import useModalSetup from "../../../../../../hooks/useModalSetup";
import ActionButton from "../../../../../../common/ActionButton";
import CustomFieldModal from "./CustomFieldModal";
import {customFieldActionsCreator} from "./CustomFieldUtils";

export default function CustomFieldEntry({ msgDataSourceId, customFields, filterCustomFieldList, customFieldsInput, handleCustomFields, disabled }) {
    const dispatch = useDispatch();
    const [refreshing, setRefreshing] = useState(false);
    const { handleOpenModal, handleCloseModal, openModal } = useModalSetup();

    const handleCustomFieldFormData = (addedCustomFields) => {
        handleCustomFields(addedCustomFields)
    }

    /**
     * Custom fields may have been added to the data source since the message was loaded (e.g. automatically after
     * a failed reply), so the list is refreshed before the modal opens.
     */
    const handleOpenWithRefreshedFields = async () => {
        if (msgDataSourceId) {
            setRefreshing(true);
            await dispatch(customFieldActions.listCustomFields(msgDataSourceId, customFieldActionsCreator.messageViewRefresh));
            setRefreshing(false);
        }
        handleOpenModal();
    }

    return(
        <Fragment>
            <ActionButton
                label={'Custom fields'}
                action={handleOpenWithRefreshedFields}
                withIcon={false}
                loading={refreshing}
                disabled={disabled}
                sx={styles.actionButton}
            />
            <CustomFieldModal
                title={'Custom fields'}
                open={openModal}
                handleClose={handleCloseModal}
                customFields={customFields}
                filterCustomFieldList={filterCustomFieldList}
                customFieldsInput={customFieldsInput}
                handleCustomFieldFormData={handleCustomFieldFormData}
            />
        </Fragment>
    )
}

const styles = {
    actionButton: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
}
